import { c as _c } from "react/compiler-runtime";
import { DateRangeCustomFilterEnum, DateRangePicker, getDate, setDateWithTimezone } from '@systemeio/components';
import { CurrencyEnum } from '@systemeio/types';
import AffiliateDashboardInvoices from 'modules/affiliate-dashboard/components/affiliate-dashboard-invoices';
import AffiliateDashboardLeads from 'modules/affiliate-dashboard/components/affiliate-dashboard-leads';
import AffiliateDashboardPayments from 'modules/affiliate-dashboard/components/affiliate-dashboard-payments';
import AffiliateDashboardPromotion from 'modules/affiliate-dashboard/components/affiliate-dashboard-promotion';
import AffiliateDashboardVendorSelector from 'modules/affiliate-dashboard/components/affiliate-dashboard-vendor-selector';
import { AffiliateDashboardLoco } from 'modules/affiliate-dashboard/constants/affiliate-dashboard-loco';
import { useAffiliateDashboardChart } from 'modules/affiliate-dashboard/hooks/use-affiliate-dashboard-chart';
import { useAffiliateDashboardStatistic } from 'modules/affiliate-dashboard/hooks/use-affiliate-dashboard-statistic';
import { useAffiliateDashboardTags } from 'modules/affiliate-dashboard/hooks/use-affiliate-dashboard-tags';
import { AffiliateDashboardFilterInterface, TagId } from 'modules/affiliate-dashboard/types/affiliate-dashboard-interface';
import AffiliateChart from 'modules/affiliate-program/affiliate/components/affiliate-chart';
import AffiliateStatistic from 'modules/affiliate-program/affiliate/components/affiliate-statistic';
import { AffiliateStatisticDateFilterInterface } from 'modules/affiliate-program/affiliate/types/affiliate-interface';
import { isDefaultFilter } from 'modules/affiliate-program/utils/is-default-filter';
import { NextPage } from 'next';
import { useEffect, useMemo, useState } from 'react';
import { FormSelect } from 'shared/components';
import { FilterHeader } from 'shared/components/filter-header';
import { useCurrencySubsetData } from 'shared/hooks/use-currency-data';
import { toFilterGroup, useFilterDraft } from 'shared/hooks/use-filter-draft';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { useFilterWithDate } from 'shared/route-query/hooks/use-filter/use-filter-with-date';
import { SelectorDataInterface } from 'shared/types/selector-data-interface';
import { getBaseServerSideProps } from 'shared/utils/get-base-server-side-props';
import { getDatePickerMinDate } from 'shared/utils/get-date-picker-min-date';
import { getMonthDateRange, getToday } from 'shared/utils/get-dates';
const defaultFilter: AffiliateDashboardFilterInterface = {
  dateTill: null,
  dateSince: null,
  vendorId: undefined,
  currency: undefined
};
const AffiliateDashboard: NextPage = () => {
  const $ = _c(95);
  const {
    t
  } = useLocoTranslation();
  const {
    user,
    intlLocale
  } = useUser();
  const [tagsData, setTagsData] = useState(undefined);
  const {
    filter,
    setFilter,
    defaultFilter: defaults
  } = useFilterWithDate(defaultFilter, getMonthDateRange);
  const {
    data: affiliateTags
  } = useAffiliateDashboardTags();
  const {
    data: affiliateStatistic
  } = useAffiliateDashboardStatistic(filter.vendorId);
  const {
    data: affiliateChart
  } = useAffiliateDashboardChart(filter);
  let t0;
  if ($[0] !== affiliateStatistic) {
    t0 = affiliateStatistic ? Object.keys(affiliateStatistic.total) as CurrencyEnum[] : undefined;
    $[0] = affiliateStatistic;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const currencies = t0;
  const currencyData = useCurrencySubsetData(currencies);
  let t1;
  let t2;
  if ($[2] !== affiliateTags) {
    t1 = () => {
      if (affiliateTags) {
        setTagsData(affiliateTags.affiliateTags.map(_temp));
      }
    };
    t2 = [affiliateTags];
    $[2] = affiliateTags;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  let t3;
  if ($[5] !== setFilter) {
    t3 = values => setFilter(values);
    $[5] = setFilter;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== defaults || $[8] !== filter || $[9] !== t3) {
    t4 = {
      applied: filter,
      defaults,
      onApply: t3
    };
    $[7] = defaults;
    $[8] = filter;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const state = useFilterDraft(t4);
  let t5;
  if ($[11] !== t) {
    t5 = t("header.top_menu.affiliate_dashboard");
    $[11] = t;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== affiliateStatistic || $[14] !== currencyData || $[15] !== intlLocale || $[16] !== state || $[17] !== t || $[18] !== user) {
    let t7;
    if ($[20] !== user?.timezone) {
      t7 = () => getMonthDateRange(user?.timezone);
      $[20] = user?.timezone;
      $[21] = t7;
    } else {
      t7 = $[21];
    }
    let t8;
    if ($[22] !== state.draft.dateSince || $[23] !== state.draft.dateTill) {
      t8 = [state.draft.dateSince, state.draft.dateTill];
      $[22] = state.draft.dateSince;
      $[23] = state.draft.dateTill;
      $[24] = t8;
    } else {
      t8 = $[24];
    }
    const t9 = user?.timezone;
    let t10;
    if ($[25] !== t9) {
      t10 = getToday(t9);
      $[25] = t9;
      $[26] = t10;
    } else {
      t10 = $[26];
    }
    let t11;
    if ($[27] !== state) {
      t11 = date => {
        const newFilterState = {
          dateSince: date[0],
          dateTill: date[1]
        };
        state.setDraft(prev => ({
          ...prev,
          ...newFilterState
        }));
      };
      $[27] = state;
      $[28] = t11;
    } else {
      t11 = $[28];
    }
    const t12 = user?.createdAt;
    const t13 = user?.timezone;
    let t14;
    if ($[29] !== t12 || $[30] !== t13 || $[31] !== user?.affiliateAccountCreatedAt || $[32] !== user?.timezone) {
      t14 = getDatePickerMinDate(t12, t13, user?.affiliateAccountCreatedAt ? getDate(user?.affiliateAccountCreatedAt, user?.timezone) : undefined, "date-range-picker");
      $[29] = t12;
      $[30] = t13;
      $[31] = user?.affiliateAccountCreatedAt;
      $[32] = user?.timezone;
      $[33] = t14;
    } else {
      t14 = $[33];
    }
    let t15;
    if ($[34] !== user) {
      t15 = [{
        slug: DateRangeCustomFilterEnum.AllTime,
        handler: () => {
          const today = setDateWithTimezone("", user?.timezone);
          today.setHours(23, 59, 59, 999);
          if (!user?.affiliateAccountCreatedAt) {
            return [today, today];
          }
          const firstDate = setDateWithTimezone(user.affiliateAccountCreatedAt, user?.timezone);
          return [firstDate, today];
        }
      }];
      $[34] = user;
      $[35] = t15;
    } else {
      t15 = $[35];
    }
    const t16 = user?.timezone;
    let t17;
    if ($[36] !== intlLocale || $[37] !== t10 || $[38] !== t11 || $[39] !== t14 || $[40] !== t15 || $[41] !== t16 || $[42] !== t7 || $[43] !== t8) {
      t17 = <DateRangePicker getDefaultDate={t7} date={t8} maxDate={t10} onChange={t11} minDate={t14} customFilters={t15} timezone={t16} intlLocale={intlLocale} />;
      $[36] = intlLocale;
      $[37] = t10;
      $[38] = t11;
      $[39] = t14;
      $[40] = t15;
      $[41] = t16;
      $[42] = t7;
      $[43] = t8;
      $[44] = t17;
    } else {
      t17 = $[44];
    }
    const t18 = !affiliateStatistic;
    let t19;
    if ($[45] !== t) {
      t19 = t("global.currency");
      $[45] = t;
      $[46] = t19;
    } else {
      t19 = $[46];
    }
    let t20;
    if ($[47] !== state) {
      t20 = data => state.setDraft(prev_0 => ({
        ...prev_0,
        currency: data
      }));
      $[47] = state;
      $[48] = t20;
    } else {
      t20 = $[48];
    }
    let t21;
    if ($[49] !== currencyData || $[50] !== state.draft.currency || $[51] !== t18 || $[52] !== t19 || $[53] !== t20) {
      t21 = <FormSelect disabled={t18} data={currencyData} placeholder={t19} value={state.draft.currency} onChange={t20} />;
      $[49] = currencyData;
      $[50] = state.draft.currency;
      $[51] = t18;
      $[52] = t19;
      $[53] = t20;
      $[54] = t21;
    } else {
      t21 = $[54];
    }
    let t22;
    if ($[55] !== state.draft.vendorId || $[56] !== state.setDraft) {
      t22 = <AffiliateDashboardVendorSelector selectedVendor={state.draft.vendorId} setFilter={state.setDraft} />;
      $[55] = state.draft.vendorId;
      $[56] = state.setDraft;
      $[57] = t22;
    } else {
      t22 = $[57];
    }
    t6 = toFilterGroup(state, [{
      key: "date",
      fields: ["dateSince", "dateTill"],
      node: t17
    }, {
      key: "currency",
      node: t21
    }, {
      key: "vendorId",
      node: t22
    }]);
    $[13] = affiliateStatistic;
    $[14] = currencyData;
    $[15] = intlLocale;
    $[16] = state;
    $[17] = t;
    $[18] = user;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  let t7;
  if ($[58] !== t5 || $[59] !== t6) {
    t7 = <div className="desktop:col-span-3 col-span-2"><FilterHeader title={t5} filters={t6} /></div>;
    $[58] = t5;
    $[59] = t6;
    $[60] = t7;
  } else {
    t7 = $[60];
  }
  let t8;
  if ($[61] !== affiliateChart || $[62] !== affiliateStatistic?.last30Days || $[63] !== filter || $[64] !== user?.timezone) {
    t8 = isDefaultFilter(filter, user?.timezone) ? affiliateStatistic?.last30Days : affiliateChart;
    $[61] = affiliateChart;
    $[62] = affiliateStatistic?.last30Days;
    $[63] = filter;
    $[64] = user?.timezone;
    $[65] = t8;
  } else {
    t8 = $[65];
  }
  let t9;
  if ($[66] !== affiliateStatistic || $[67] !== filter.currency || $[68] !== t8) {
    t9 = <AffiliateChart affiliateStatistic={affiliateStatistic} selectedCurrency={filter.currency} chartData={t8} />;
    $[66] = affiliateStatistic;
    $[67] = filter.currency;
    $[68] = t8;
    $[69] = t9;
  } else {
    t9 = $[69];
  }
  let t10;
  let t11;
  if ($[70] !== filter || $[71] !== setFilter || $[72] !== tagsData) {
    t10 = <div><AffiliateDashboardPayments setMainFilter={setFilter} mainFilter={filter} tagsData={tagsData} /></div>;
    t11 = <div><AffiliateDashboardLeads setMainFilter={setFilter} mainFilter={filter} tagsData={tagsData} /></div>;
    $[70] = filter;
    $[71] = setFilter;
    $[72] = tagsData;
    $[73] = t10;
    $[74] = t11;
  } else {
    t10 = $[73];
    t11 = $[74];
  }
  let t12;
  if ($[75] !== filter || $[76] !== setFilter) {
    t12 = <div><AffiliateDashboardInvoices mainFilter={filter} setMainFilter={setFilter} /></div>;
    $[75] = filter;
    $[76] = setFilter;
    $[77] = t12;
  } else {
    t12 = $[77];
  }
  let t13;
  if ($[78] !== t10 || $[79] !== t11 || $[80] !== t12 || $[81] !== t9) {
    t13 = <div className="col-span-2 flex flex-col gap-5">{t9}{t10}{t11}{t12}</div>;
    $[78] = t10;
    $[79] = t11;
    $[80] = t12;
    $[81] = t9;
    $[82] = t13;
  } else {
    t13 = $[82];
  }
  let t14;
  if ($[83] !== affiliateStatistic || $[84] !== filter.currency) {
    t14 = <AffiliateStatistic isDashboard={true} selectedCurrency={filter.currency} affiliateStatistic={affiliateStatistic} />;
    $[83] = affiliateStatistic;
    $[84] = filter.currency;
    $[85] = t14;
  } else {
    t14 = $[85];
  }
  const t15 = affiliateStatistic?.user.affiliateAccount.affiliateId;
  let t16;
  if ($[86] !== t15) {
    t16 = <AffiliateDashboardPromotion affiliateId={t15} />;
    $[86] = t15;
    $[87] = t16;
  } else {
    t16 = $[87];
  }
  let t17;
  if ($[88] !== t14 || $[89] !== t16) {
    t17 = <div className="desktop:col-span-1 desktop:row-start-auto col-span-2 row-start-3 flex flex-col gap-5">{t14}{t16}</div>;
    $[88] = t14;
    $[89] = t16;
    $[90] = t17;
  } else {
    t17 = $[90];
  }
  let t18;
  if ($[91] !== t13 || $[92] !== t17 || $[93] !== t7) {
    t18 = <><div className="desktop:grid-cols-3 grid grid-flow-row grid-cols-2 gap-5">{t7}{t13}{t17}</div></>;
    $[91] = t13;
    $[92] = t17;
    $[93] = t7;
    $[94] = t18;
  } else {
    t18 = $[94];
  }
  return t18;
};
export const getServerSideProps = getBaseServerSideProps(AffiliateDashboardLoco, 'header.top_menu.affiliate_dashboard');
export default AffiliateDashboard;
function _temp(el) {
  return {
    id: el.id,
    caption: el.name
  };
}